import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ISelectionButton } from '../selection-button/selection-button.component';

@Component({
  selector: 'app-selection-buttons-container',
  templateUrl: './selection-buttons-container.component.html',
  styleUrls: ['./selection-buttons-container.component.scss'],
})
export class SelectionButtonsContainerComponent implements OnInit {
  @Input() public title: string;
  @Input() public buttonsArrayBehaviorSubject: BehaviorSubject<BehaviorSubject<ISelectionButton>[]>;
  @Output() public buttonOnClick = new EventEmitter<ISelectionButton>();
  public buttonsArray: BehaviorSubject<ISelectionButton>[];

  private _selectedButton?: ISelectionButton;

  ngOnInit(): void {
    this.buttonsArrayBehaviorSubject.subscribe((buttonsArray) => {
      this.buttonsArray = buttonsArray;
      this._selectedButton = undefined;
      this._initSelection();
    });

    this._initSelection();
  }

  public onSelection(newSelectedButton: ISelectionButton, emitEvent = true) {
    if (this._selectedButton) {
      if (this._selectedButton.id === newSelectedButton.id) {
        return;
      }
      const currentSelectedButtonIndex = this._getButtonIndex(this._selectedButton);
      if (currentSelectedButtonIndex == -1) {
        throw new Error(
          'SelectionButtonsContainerComponent: Something is wrong - should not get negative button index'
        );
      }
      this._selectedButton.selected = false;
      this.buttonsArray[currentSelectedButtonIndex].next(this._selectedButton);
    }

    this._selectedButton = newSelectedButton;
    this._selectedButton.selected = true;
    const newSelectedButtonIndex = this._getButtonIndex(this._selectedButton);
    if (newSelectedButtonIndex == -1) {
      throw new Error('SelectionButtonsContainerComponent: Something is wrong - should not get negative button index');
    }
    this.buttonsArray[newSelectedButtonIndex].next(this._selectedButton);

    if (emitEvent) {
      this.buttonOnClick.emit(newSelectedButton);
    }
  }

  private _getButtonIndex(selectedButton: ISelectionButton) {
    for (const [index, btn] of this.buttonsArray.entries()) {
      if (btn.getValue().id == selectedButton.id) {
        return index;
      }
    }

    return -1;
  }

  private _initSelection() {
    for (let index = 0; index < this.buttonsArray.length; index++) {
      if (this.buttonsArray[index].value.selected) {
        this.onSelection(this.buttonsArray[index].value, false);
        break;
      }
    }
  }
}
